module.exports = __webpack_public_path__ + "static/creation-logo-1352f60b7a1a89bb960e6dad38760d96.png";